import nameCreativeGroupModalTpl from '../templates/name_creative_group_modal.directive.html';

export default function NameCreativeGroupModalController($scope, $modal) {
  const vm = this;
  vm.open = open;

  function open() {
    $modal.open({
      animation: true,
      template: nameCreativeGroupModalTpl,
      controller: NameCreativeGroupModalInstanceController,
      controllerAs: 'modalInstanceVm',
      scope: $scope,
      size: 'md'
    });
  }

  return vm;
}

NameCreativeGroupModalController.$inject = ['$scope', '$modal', '$q'];

function NameCreativeGroupModalInstanceController(
  $scope,
  $state,
  $modalInstance,
  CreativeGroupService,
  FlashService,
  SaveCreativeService
) {
  var vm = this;
  vm.cancel = cancel;
  vm.creativeGroupService = CreativeGroupService;
  vm.save = save;

  function save() {
    return SaveCreativeService.saveGroup(CreativeGroupService.group).then(
      response => {
        CreativeGroupService.group.id = response.data.id;
        $state.go('creativePreview.showPreviewGroup', {
          id: response.data.id
        });

        cancel();
        return;
      },
      () => {
        FlashService.push('error', 'Something went wrong. Please try again.');
      }
    );
  }
  function cancel() {
    $modalInstance.close(false);
  }

  return vm;
}

NameCreativeGroupModalInstanceController.$inject = [
  '$scope',
  '$state',
  '$modalInstance',
  'CreativeGroupService',
  'FlashService',
  'SaveCreativeService'
];
